export const transformTransparentPixelsToWhite = (canvas: HTMLCanvasElement, size: number) => {
  const ctx = canvas.getContext('2d');
  const currentPixels = ctx?.getImageData(0, 0, size, size);

  if (currentPixels) {
    // alpha is index 3 in RGBA so iterate starting from index 3 with jumps of 4
    for (let alpha = 3; alpha < currentPixels?.data.length; alpha += 4) {
      // replace the pixel by a white pixel if it's fully transparent
      if (currentPixels.data[alpha] === 0) {
        currentPixels.data[alpha] = 255;
        currentPixels.data[alpha - 1] = 255;
        currentPixels.data[alpha - 2] = 255;
        currentPixels.data[alpha - 3] = 255;
      }
    }
    ctx?.putImageData(currentPixels, 0, 0);
  }
};

/**
 * Create a (hidden) canvas element to resize the uploaded image to 128x128
 */
export const generateResizedCanvas = (
  originalCanvas: HTMLCanvasElement | HTMLImageElement,
  resizedImageResolution: number
): HTMLCanvasElement => {
  const originalWidth = originalCanvas.width;
  const originalHeight = originalCanvas.height;
  const wider = originalWidth === Math.max(originalWidth, originalHeight);
  const resizedCanvas = document.createElement('canvas');
  resizedCanvas.width = wider
    ? resizedImageResolution
    : resizedImageResolution * (originalWidth / originalHeight);
  resizedCanvas.height = wider
    ? resizedImageResolution * (originalHeight / originalWidth)
    : resizedImageResolution;
  resizedCanvas
    .getContext('2d')
    ?.drawImage(
      originalCanvas,
      0,
      0,
      originalCanvas.width,
      originalCanvas.height,
      0,
      0,
      resizedCanvas.width,
      resizedCanvas.height
    );

  return resizedCanvas;
};

/**
 * Returns the class name for the top disclaimer offset
 */
export const getDisclaimerTopClassName = (disclaimerSize: 0 | 1 | 2) => {
  switch (disclaimerSize) {
    case 0:
      return 'offset-topNav';
    case 1:
      return 'offset-topNav-disclaimer';
    case 2:
      return 'offset-topNav-double-disclaimer';
  }
};

/**
 * Returns the class name for the height of the components that are offset by the top disclaimer
 */
export const getDisclaimerHeightClassName = (
  disclaimerSize: 0 | 1 | 2,
  innerPage: boolean = false
) => {
  switch (disclaimerSize) {
    case 0:
      return `h-offset-topNav${innerPage ? '-inner' : ''}`;
    case 1:
      return `h-offset-topNav-disclaimer${innerPage ? '-inner' : ''}`;
    case 2:
      return `h-offset-topNav-double-disclaimer${innerPage ? '-inner' : ''}`;
  }
};
